export default "__VITE_ASSET__41484a8e__"